function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A770",
  fillRule: "evenodd",
  d: "M2.412 5.197a10.095 10.095 0 004.39 4.391L8.27 8.122c.18-.18.446-.24.68-.16.746.247 1.552.38 2.378.38.367 0 .666.3.666.666v2.326c0 .366-.3.666-.666.666C5.071 12 0 6.93 0 .673 0 .306.3.007.666.007h2.332c.367 0 .667.3.667.666 0 .833.133 1.632.38 2.379a.67.67 0 01-.167.68L2.412 5.196zm9.022-4.73L10.96 0 6.663 4.198V1.339h-.666v3.998h3.997v-.666H7.23L11.434.466z"
})));